export const renderNames = (name, type) => {
  let res = ''
  if (name && name.firstName) res += name.firstName + ' '
  if (name && name.middleName) res += name.middleName + ' '
  if (name && name.lastName) res += name.lastName
  if (name && name.companyGeneralDetails?.legalName) res = name.companyGeneralDetails.legalName
  if (res === '') res = type + ' Without Name'
  return res
}
